import { BorderOutsideIcon } from './BorderOutsideIcon';

/**
 * author: Google
 * id F8EA9B00-82F1-4DE8-B8B5-0A71B934C44D
 * name border-outside
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/border-outside.svg
 * tags
 * - Text / Content / Format 
 */
export const BorderOuterIcon = BorderOutsideIcon;
export default BorderOuterIcon